import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import toast from 'react-hot-toast';

const Signup = () => {
  var [name, setName] = useState('');
  var [email, setEmail] = useState('');
  var [password, setPassword] = useState('');
  var [confirmPassword, setConfirmPassword] = useState('');
  var [loading, setLoading] = useState(false);
  var { signup } = useAuth();
  var navigate = useNavigate();
  var location = useLocation();

  var adminVerified = (location.state && location.state.adminVerified) || localStorage.getItem('adminToken');

  useEffect(function () {
    if (!adminVerified) {
      toast.error('Admin access required');
      navigate('/login');
    }
  }, [adminVerified, navigate]);

  if (!adminVerified) return null;

  var handleSubmit = async function (e) {
    e.preventDefault();
    if (password !== confirmPassword) { toast.error('Passwords do not match'); return; }
    if (password.length < 6) { toast.error('Password min 6 characters'); return; }
    setLoading(true);
    try {
      await signup(name, email, password);
      toast.success('Company account created!');
      navigate('/dashboard');
    } catch (error) {
      toast.error((error.response && error.response.data && error.response.data.message) || 'Failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4" style={{ background: 'linear-gradient(135deg, #f0fdf4 0%, #ffffff 50%, #f0fdf4 100%)' }}>
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <img src="/logo.jpg" alt="Vasify" className="w-16 h-16 mx-auto mb-4 rounded-2xl object-contain" onError={(e) => { e.target.style.display = 'none'; }} />
          <h1 className="text-3xl font-bold text-gray-900">Vasify <span style={{ color: '#25D366' }}>CRM</span></h1>
          <p className="text-gray-500 mt-2">Create a new company account</p>
        </div>

        <div className="flex justify-center mb-4">
          <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800">🔐 Admin Verified</span>
        </div>

        <div className="bg-white rounded-2xl shadow-xl border border-gray-100 p-8">
          <form onSubmit={handleSubmit} className="space-y-5">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1.5">Company Name</label>
              <input type="text" value={name} onChange={(e) => setName(e.target.value)} className="input-field" placeholder="Company Name" required />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1.5">Email</label>
              <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="input-field" placeholder="company@example.com" required />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1.5">Password</label>
              <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="input-field" placeholder="••••••••" required minLength={6} />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1.5">Confirm Password</label>
              <input type="password" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} className="input-field" placeholder="••••••••" required />
            </div>
            <button type="submit" disabled={loading} className="btn-primary w-full py-2.5">{loading ? 'Creating...' : 'Create Company Account'}</button>
          </form>
          <div className="mt-6 text-center">
            <button onClick={() => navigate('/login')} className="text-sm text-gray-500 hover:text-gray-700">← Back to Login</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Signup;